module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-a0f7a83c6c62222fbcaab1fd416ac0e8.png";